module.exports = fox._r("images/pictures.gif", __webpack_public_path__ + "images/pictures.gif");


//////////////////
// WEBPACK FOOTER
// ./images/pictures.gif
// module id = 1091
// module chunks = 4